module.exports = __webpack_public_path__ + "static/media/monitoring.669284a2.svg";